import { Button } from '@athena/forge';
import { getLocalizedString } from '../../utils/i18n-utils';
import AmplitudeUtils from '../../utils/amplitude-utils';
import { launchLwa } from '../../utils/lwa-utils';
const CREATE_ACCOUNT_HASH = '#create';
export default function Registration() {
  return (
    <div className={'fe_u_text-align--center fe_u_margin--top-large'}>
      <span className="fe_u_margin--right-xxsmall">{getLocalizedString('registration.signup.label')}</span>
      <Button text={getLocalizedString('registration.signup.text')} variant="tertiary" onClick={async () => {
        await AmplitudeUtils.logCustomEvent('SignUpButtonClick', {});
        await launchLwa({ hash: CREATE_ACCOUNT_HASH });
      }}></Button>
    </div>
  );
}
